<template>
    <div :class="[
    'form',
    'form__numberradiohorizontal',
    `form__numberradiohorizontal--number-${numberSize}`
    ]">
        <label
            v-if="label"
            :class="[
                'form__numberradiohorizontal_title'
            ]"
            :for="name  | toKebabCase"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></label>
        <template v-if="$slots.default && hintPositionTop">
            <div class="form__numberradiohorizontal_hint form__numberradiohorizontal_hint--top">
                <slot></slot>
            </div>
        </template>
        <div class="form__numberradiohorizontal_fields">
            <div class="columns is-vcentered">
                <div class="column is-narrow">
                    <div class="form__numberradiohorizontal_fields_number">
                        <input
                            :disabled="disabled || disabledNumber"
                            type="number"
                            title="Count"
                            min="0"
                            :max="maxNumber"
                            :id="name | toKebabCase"
                            :name="name | toKebabCase"
                            :value="valueNumber"
                            v-validate="vValidate"
                            :data-vv-as="dataVvAs ? dataVvAs : label.toLowerCase()"
                            @input="emitValueNumber"
                            @focus="emitFocus"
                            @blur="emitBlur"
                        >
                    </div>
                </div>
                <div class="column column--top is-narrow">
                    <fieldset>
                        <template
                            v-for="(item, index) in items"
                        >
                            <label
                                :for="(name + '-' +  item.value) | toKebabCase"
                                :key="index"
                            >
                                <input
                                    :disabled="disabled"
                                    type="radio"
                                    class="form__numberradiohorizontal_fields_input"
                                    :id="(name + '-' +  item.value) | toKebabCase"
                                    :title="item.name | toKebabCase"
                                    :value="item.value | toKebabCase"
                                    :name="name | toKebabCase"
                                    v-model="newValueRadio"
                                >
                                <span
                                    class="form__numberradiohorizontal_fields_text">{{item.name | toCapitalize}}</span>
                            </label>
                        </template>
                    </fieldset>
                </div>
                <div class="column">
                    <div class="form__numberradiohorizontal_fields_text">{{after}}</div>
                </div>
            </div>
        </div>
        <span
            class="form__error form__numberradiohorizontal_error"
            v-if="errors.first(toKebabCase(name))"
        >{{ errors.first(toKebabCase(name)) }}</span>
        <template v-if="$slots.default && !hintPositionTop">
            <div class="form__numberradiohorizontal_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import { toKebabCase } from '@/functions'
import { maxNumber } from '@/variables'

export default {
  name: 'form-number-radio-horizontal',
  data () {
    return {
      maxNumber
    }
  },
  props: {
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    after: {
      type: String,
      default: ''
    },
    valueNumber: {
      required: true,
      default: 0
    },
    valueRadio: {
      type: [String, Number],
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledNumber: {
      type: Boolean,
      default: false
    },
    disabledRadio: {
      type: Boolean,
      default: false
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidate: {
      default: ''
    },
    numberSize: {
      type: String,
      default: 'small'
    },
    hintPositionTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newValueRadio: {
      get () {
        return this.valueRadio
      },
      set (value) {
        this.$emit('emit-value-radio', value)
      }
    }
  },
  methods: {
    emitFocus () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.pause()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-focus')
    },
    emitBlur () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.resume()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-blur')
    },
    emitValueNumber (event) {
      this.$emit('emit-value-number', Number(event.target.value))
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formnumberradiohorizontal";
</style>
